// Auth API — proxied to qtz-account backend via the /account Vite dev proxy.
// These are unauthenticated calls (no Bearer token required).

const BASE = import.meta.env.VITE_BASE_URL ?? ''

export interface LoginRequest {
  email: string
  password: string
}

export interface TokenPairResponse {
  access_token: string
  refresh_token: string
  expires_at: string
  token_type: string
}

async function authRequest<T>(path: string, body: unknown): Promise<T> {
  const resp = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!resp.ok) {
    let message = resp.statusText
    try {
      const data = await resp.json()
      message = data?.error?.message ?? message
    } catch {
      // ignore
    }
    throw new Error(`[${resp.status}] ${message}`)
  }
  return resp.json() as Promise<T>
}

export const authApi = {
  login(body: LoginRequest): Promise<TokenPairResponse> {
    return authRequest('/account/api/v1/auth/login', body)
  },

  refresh(refreshToken: string): Promise<TokenPairResponse> {
    return authRequest('/account/api/v1/auth/refresh', { refresh_token: refreshToken })
  },

  logout(refreshToken: string): Promise<void> {
    return authRequest('/account/api/v1/auth/logout', { refresh_token: refreshToken })
  },
}
